import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconSettings, IconTrashX } from '@tabler/icons';
import { FC } from 'react';
import { openDeleteGoogleAccountModal } from './DeleteGoogleAcountModal';

interface Props {
  accountId: number;
  manageGoogleAccount: () => void;
  removeAccount: () => void;
}

const GoogleAccountActions: FC<Props> = ({ accountId, manageGoogleAccount, removeAccount }) => (
  <div>
    <Menu shadow="md" width={150} transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconSettings size={16} />} onClick={() => manageGoogleAccount()}>
          Einstellungen
        </Menu.Item>
        <Menu.Item
          color="red"
          icon={<IconTrashX size={16} />}
          onClick={() => openDeleteGoogleAccountModal(accountId, removeAccount)}
        >
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  </div>
);

export default GoogleAccountActions;
